import moment from 'moment';
import {
  DataGrid,
  gridClasses,
} from '@mui/x-data-grid';
import { styled } from '@mui/material/styles';
import { Origin } from '../models/general'
import * as XLSX from 'xlsx';
import {ProjectModel} from '../models';

const DATETIME_FORMAT = 'MM/DD/yyyy, hh:mm A';
const DATETIME_FORMAT_WITH_SECONDS = 'MM/DD/yyyy, hh:mm:ss A';
const DATE_FORMAT = 'MM/DD/yyyy';
const TIME_FORMAT = 'hh:mm A';

export const APP_NAME = process.env.REACT_APP_ORIGIN


export const TYPYING_SPEED = parseInt(process.env.REACT_APP_CHAT_TYPING_SPEED || "10")

export function getAppName(): string {
  return toTitleCase(APP_NAME);
}

export function setTitle(title: string) {
  if (!title) {
    title = getAppName()
  }else{
    title = `${getAppName()} - ${title}`
  }
  document.title = title
}

export const DISPLAY_COMPARING_MODEL_ID = process.env.REACT_APP_DISPLAY_COMPARING_LLM_ID === 'show'


export const isURL = (text:  string) => {
  const urlPattern = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\S*)$/;
  return urlPattern.test(text);
}

export const getDomain = (url) => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.hostname;
  } catch (error) {
    return url;
  }
};

export const isRegeneratable = (modelTypes: string[],modelType: string) => {
  return modelTypes?.indexOf(modelType) !== -1
}


export const shuffleArray = (array) => {
  let shuffledArray = array.slice(); // Create a copy of the array
  for (let i = shuffledArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]]; // Swap elements
  }
  return shuffledArray;
};

export const convertToDateTimeWithSeconds = (dateTimeString: string): string => {
  return dateTimeString ? moment.utc(dateTimeString).local().format(DATETIME_FORMAT_WITH_SECONDS) : '-';
};

export const convertToDateTime = (dateTimeString: string): string => {
  return dateTimeString ? moment.utc(dateTimeString).local().format(DATETIME_FORMAT) : '-';
};

export const convertToTime = (dateTimeString: string): string => {
  return dateTimeString ? moment.utc(dateTimeString).local().format(TIME_FORMAT) : '-';
};

export const convertToDate = (dateTimeString: string): string => {
  return dateTimeString ? moment.utc(dateTimeString).local().format(DATE_FORMAT) : '-';
};


export const toTitleCase = (str) => {
  return str
    .toLowerCase()
    .replaceAll('_', ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  border: 0,
  [`& .MuiDataGrid-topContainer`]: {
    '--DataGrid-containerBackground':'none',
    '--DataGrid-pinnedBackground':'none',
    '--DataGrid-rowBorderColor':'var(--bs-gray-400) !important;',
    'margin-bottom': '1rem'
  },
  [`& .${gridClasses.footerContainer}`]: {
    'margin-top': '1rem'
  },
  [`& .${gridClasses.footerContainer}, & .MuiDataGrid-root`]: {
    'border-color' : 'var(--bs-gray-400) !important;',
    'height' :'50px'
  },
  [`& .${gridClasses.row}`]: {
    '--rowBorderColor': 'none',
  },
  [`& .${gridClasses.row}:hover`]: {
    backgroundColor: 'var(--bs-text-gray-300) !important'
  },
  [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within, & .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]:
    {
      outline: 'none'
    },
    '& .MuiDataGrid-columnSeparator, & .MuiDataGrid-filler': {
      display: 'none',
    },
    '& .MuiTablePagination-root':{
      'font-size': '1.15rem !important'
    },
    '& .MuiDataGrid-sortIcon, & .MuiTablePagination-root, & .MuiTablePagination-selectIcon, & .MuiIconButton-root:not(.Mui-disabled)': {
      'color': 'var(--bs-text-gray-700) !important'
    },
    '& .MuiTablePagination-displayedRows, & .MuiTablePagination-selectLabel': {
      'font-size': '1.15rem !important',
      'margin': 0
    }
}));

export const dataGridHeaderClassName = 'fs-5 text-gray-700 text-start p-lg-4 p-2'
export const dataGridCellClassName = 'fs-6 text-gray-700 text-start p-lg-4 p-2'


export const classifyDate = (dateTime: Date, locale: string, intl: any): string => {
  moment.locale(locale);
  const date = moment(dateTime);
  const now = moment();

  if (date.isSame(now, 'day')) {
    return intl.formatMessage({id: `general.date.today`});
  } else if (date.isSame(now.clone().subtract(1, 'days'), 'day')) {
    return intl.formatMessage({id: `general.date.yesterday`});
  } else if (date.isAfter(now.clone().subtract(7, 'days'), 'day')) {
    return intl.formatMessage({id: `general.date.previous_7_days`});
  } else if (date.isAfter(now.clone().subtract(30, 'days'), 'day')) {
    return intl.formatMessage({id: `general.date.previous_30_days`});
  } else {
    const yearsDiff = now.diff(date, 'years');
    const monthsDiff = now.diff(date, 'months') % 12;
    const monthName = date.format('MMMM');
    
    if (yearsDiff >= 1) {
      if (monthsDiff > 0) {
        return `${monthName} ${date.year()}`;
      } else {
        return `${monthName} ${date.year()}`;
      }
    } else {
      return `${monthName}`;
    }
  }
};
export const escapeHtml = (text: string) => {
  return text.replace(/[&<>"']/g, (match) => {
    const map: Record<string, string> = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    };
    console.log(match)
    return map[match];
  }).replace(/\n/g, '&#013;');
};

export const removeAttirubtionTags = (revised_response: string) => {
  return revised_response.replace(/<(?:conflict|support)[^>]*>|<\/(?:conflict|support)>/g, '');
}

const removeCitationsFromAttributes = (markdown) => {
  return markdown.replace(
    /<(support|conflict)([^>]*)>/g,
    (match, tag, attrs) => {
      const modifiedAttrs = attrs.replace(/(\[\d+\])/g, (match) => match.replace(/\[|\]/g, ''));
      return `<${tag}${modifiedAttrs}>`.trim(); // Trim to clean up any extra spaces
    }
  );
};

const adjustAttributionTags = (markdown) => {
  return markdown.replace(
    /<(support|conflict)([^>]*)>(\d+\.\s*)(.*?)<\/\1>/g,
    (_, tag, attrs, listNumber, content) => {
      return `${listNumber}<${tag}${attrs}>${content}</${tag}>`;
    }
  );
};

export const replaceAttributionWithHTML = (content) => {
  const pattern = /(<(conflict|support)[^>]*?)\breason\b="([^"]*)"/g;
  const updatedContent = adjustAttributionTags(removeCitationsFromAttributes(content)).replace(pattern, (match, p1, p2, p3) => {
    return `${p1} title="${p3}"`;
  });
  return updatedContent.replaceAll(
    "<conflict",
    '<span class="dotted-underline"'
  ).replaceAll(
    "</conflict>",
    '</span>'
  ).replaceAll(
    "<support",
    '<span class="dotted-underline"'
  ).replaceAll(
    "</support>",
    '</span>'
  )
};

export const parseAttributedResponse = (revised_response:string, references: any): string => {
  if( typeof revised_response === 'string'){
    let attributed_response = revised_response.trim();
    const parts = attributed_response.split(/(\[\d+\])/g);
    let currentIndex = -1
    const updatedResponse = parts.map((part) => {
      const match = part.match(/\[\d+\]/);
      if (match) {
        const number = match[0].match(/\d+/)?.[0];
        currentIndex++
        if (number && references[currentIndex]) {
          return `[[${parseInt(number)}]](${references[currentIndex].url} "${escapeHtml(references[currentIndex].support_text)}")`;
        }
      }
      return part;
    }).join('');
    return updatedResponse;
  }else{
    return ''
  }
}

const convertObjectsToRows = (objects, headers) => {
  if (objects.length === 0) return [Object.keys(objects[0])]; // Return header if no objects

  headers = headers || Object.keys(objects[0]);
  const rows = objects.map(obj => headers.map(header => obj[header]));
  
  return [headers, ...rows];
}

const escapeCsvValue = (value: any) => {
  if (typeof value === 'string') {
    const escapedValue = value.replace(/"/g, '""');
    return (escapedValue.includes(',') || escapedValue.includes('\n') || escapedValue.includes('"')) 
      ? `"${escapedValue}"` 
      : escapedValue;
  }
  return value;
}

export const downloadObjects = async (type: string = 'excel', objects: any[], name: string, headers?: string[]) => {
  if(type === 'excel'){
    const rows = convertObjectsToRows(objects, headers);

    const ws = XLSX.utils.aoa_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, `Messages`);

    const blob = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const url = URL.createObjectURL(new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
    
    const a = document.createElement('a');
    a.href = url;
    a.download = `${getAppName()} - ${name}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }else if (type == 'csv'){
    const rows = convertObjectsToRows(objects, headers);
    const csv = rows.map(row => row.map(value => escapeCsvValue(value)).join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `${getAppName()} - ${name}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
}
const unicodeFixMap = {
  '\uFD41': 'رضي الله عنه',
  '\uFD42': 'رضي الله عنها',
  '\uFD4E': 'جل جلاله',
};

function fixUnicodePresentationForms(text) {
  return text.replace(/[\uFD41\uFD42\uFD4E]/g, (char) => unicodeFixMap[char] || char);
}

export const decodeUnicode = (str: string | undefined) => {
  str = fixUnicodePresentationForms(str || '');
  return typeof str === 'string' ? str.replace(/\\u[\dA-F]{4}/gi, function(match) {
    return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
  }) : '';
}

export const removeThinkingPart = (text: string) =>{
  if (!text) return ''
  return text.includes('</think>') ? text.split('</think>')[1].trim() : text
}

export const getThinkingPart = (text: string) =>{
  if (!text) return undefined
  return text.includes('</think>') ? text.split('</think>')[0].trim() : undefined
}

export const determineDirection = (text) => {
  text = text.replace(/```[\s\S]*?```/g, ''); // Remove markdown code blocks
  text = text.replace(/\[.*?\]\(.*?\)/g, ''); // Remove markdown links
  text = text.replace(/<\/?[^>]+(>|$)/g, ''); // Remove HTML-like tags
  const rtlChars = /[\u0590-\u06FF]/;
  let rtlCount = 0;
  let ltrCount = 0;

  for (let i = 0; i < text.length; i++) {
    if (rtlChars.test(text[i])) {
      rtlCount++;
    } else {
      ltrCount++;
    }
  }

  return rtlCount > ltrCount ? "rtl" : "ltr";
};


export const base64ToBlob = (base64Url: string) => {
  if (!base64Url) {
    return null;
  }
  
  let [metadata, data] = base64Url.split(',');
  const match = metadata.match(/:(.*?);/);
  const mime = match ? match[1] : 'application/octet-stream'; // fallback!

  const byteString = atob(data);
  const arrayBuffer = new Uint8Array(byteString.length);

  for (let i = 0; i < byteString.length; i++) {
    arrayBuffer[i] = byteString.charCodeAt(i);
  }

  return new Blob([arrayBuffer], { type: mime });
}